<template>
  <SysDialog v-model="dialog_ativo" :largura="500">
    <template #titulo>
      <div class="d-flex align-center">
        <v-icon color="#444444">mdi-progress-clock</v-icon>

        <div class="ml-1">
          <p class="font-18 ma-0">Processamento</p>
          <p class="font-12 font-weight-regular text-gray-1000 ma-0 mt-n3">
            Processamento de informações atrasadas ou não processadas
          </p>
        </div>
      </div>
    </template>

    <p class="ma-0 pb-3">
      <template v-if="data_ultimo_processamento !== null">
        {{ `Última análise de compras processada em ${data_ultimo_processamento}.` }}
      </template>

      <template v-else>
        Análise de compras não processadas para este fornecedor.
      </template>

      Deseja atualizar a análise de compras?
    </p>

    <template #actions>
      <v-btn outlined color="#D3D3D3" class="text-none bar-8 px-3" @click="dialog_ativo = false">
        <span class="text-black font-weight-regular">Fechar</span>
      </v-btn>

      <v-btn
        color="#042333"
        class="text-none bar-8 px-3 ml-5"
        @click="processarAnalise"
      >
        <span class="text-white font-weight-regular">Sim, atualizar análise</span>
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import {mapGetters} from "vuex";

export default {
  name: "AlertaProcessamento",
  components: {
    SysDialog
  },
  props: {
    fornecedor: Number,
  },
  emits: ["processar-analise"],
  data: () => ({
    dialog_ativo: false,
    data_ultimo_processamento: null,
  }),
  computed: {
    ...mapGetters({
      fornecedor_tela_compras: "fornecedor/getFornecedor",
    }),
  },
  watch: {
    fornecedor() {
      this.verificarProcessamento();
    }
  },
  created() {
    this.verificarProcessamento();
  },
  methods: {
    verificarProcessamento() {
      if (this.$route.name !== 'Compra') {
        return;
      }

      const params = {
        fornecedor: this.fornecedor,
        grupo_analise_fornecedores: this.fornecedor_tela_compras.grupo_analise_fornecedores ? 'S' : 'N',
      }

      api.get('grupo-compras-usuario/verificacao-processamento', { params })
        .then(resp => {
          this.data_ultimo_processamento = resp.data.dados.data_ultimo_processamento;

          if (resp.data.dados.informacoes_nao_processadas) {
            this.dialog_ativo = true;
          }
        })
        .catch(logout)
    },
    processarAnalise() {
      this.$emit("processar-analise", {});
      this.dialog_ativo = false;
    }
  }
}
</script>

<style scoped>

</style>
